import { assertPopulatedDeep } from '@dreamstack/payload/src/lib/assertPopulated'
import { RouterOutputs } from '@dreamstack/trpc/client'
import map from 'lodash/map'
import type { FunctionComponent } from 'react'
import { BodyText, HeadingH2 } from '../layout/Texts'
import { CallToActionTile } from './CallToActionTile'

export const VirtualRoundtrip: FunctionComponent<
  React.PropsWithChildren<{
    projectLinkSection: NonNullable<
      NonNullable<
        RouterOutputs['cms']['getProjectPage']['projectPage']
      >['linkSection']
    >[number]
  }>
> = ({ projectLinkSection }) => {
  assertPopulatedDeep(projectLinkSection)
  const links = projectLinkSection?.links
  return (
    <>
      <HeadingH2 className="col-span-12 mt-px-48 md:mt-px-96 lg:col-start-2 lg:col-span-10">
        {projectLinkSection.title}
      </HeadingH2>
      <BodyText className="col-span-12 lg:col-start-2 lg:col-span-8 mt-px-32 mb-px-40">
        {projectLinkSection.description}
      </BodyText>
      <div className="col-span-12  mt-px-16 md:mt-px-80">
        <div className="grid grid-cols-1 gap-px-16 md:grid-cols-3 md:gap-px-48 lg:grid-cols-4">
          {map(links, (link, i) => (
            <CallToActionTile
              backgroundImageUrl={link!.backgroundImage?.url ?? undefined}
              targetBlank
              caption={link?.title ?? ''}
              href={link?.link ?? ''}
              key={`${i}${link?.link ?? ''}`}
            />
          ))}
        </div>
      </div>
    </>
  )
}
